import React from "react";
import { Pin, Tee, Onesie, Sock, Dress, Bib } from "../common/garments";

// A sagging clothesline with tiny garments that sway. The line's centre is
// where the sign-in tag's string hangs from (x = 300 in the viewBox).
//
// The line is a quadratic curve from (0,20) via (300,70) to (600,20), so a
// point at fraction t along it sits at x = 600t, y = 20 + 100t(1 - t).
const lineY = (x) => {
  const t = x / 600;
  return 20 + 100 * t * (1 - t);
};

const GARMENTS = [
  { x: 64, Item: Tee, duration: 3.2 },
  { x: 168, Item: Onesie, duration: 3.8 },
  { x: 222, Item: Sock, duration: 2.8 },
  { x: 266, Item: Sock, duration: 3.1 },
  { x: 380, Item: Bib, duration: 3.5 },
  { x: 450, Item: Dress, duration: 4.1 },
  { x: 540, Item: Tee, duration: 3, color: "#6FD3B5" },
];

const Clothesline = () => (
  <svg
    className="kd-clothesline"
    viewBox="0 0 600 150"
    preserveAspectRatio="xMidYMin meet"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M0 20 Q300 70 600 20" className="kd-cl-line" />
    {/* String from the line down to the sign-in tag */}
    <path d="M300 45 V150" className="kd-cl-string" />
    {GARMENTS.map(({ x, Item, duration, color }, index) => (
      <g key={index} transform={`translate(${x} ${lineY(x)})`}>
        <g
          className="kd-cl-swing"
          style={{
            animationDuration: `${duration}s`,
            animationDelay: `${-index * 0.7}s`,
          }}
        >
          <g transform="translate(0 4) scale(1.2)">
            <Item color={color} />
          </g>
          <Pin />
        </g>
      </g>
    ))}
  </svg>
);

export default Clothesline;
